<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input v-model="pgData.ggcode"  placeholder="中标公告编号" clearable></el-input>
            </el-form-item>
             <el-form-item slot="title">
                 <el-input v-model="pgData.ggname"  placeholder="中标公告名称" clearable></el-input>
            </el-form-item>
        </my-search>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="中标公告编号" prop="ggcode" fixed min-width="200"></el-table-column>
            <el-table-column label="中标公告名称" prop="by1" min-width="200"></el-table-column>
            <el-table-column label="标段编号" prop="bdcode" min-width="200"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="200"></el-table-column>
            <el-table-column label="添加时间" prop="addtime"  sortable min-width="200"></el-table-column>
            <el-table-column label="添加人" prop="addusername" min-width="200"></el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button
                    type="text"
                    icon="el-icon-warning"
                    @click="editHandler({ggcode:scope.row.ggcode})">
                        退回
                    </el-button>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/Zbdl/tuihui/get_zhongbiaoggList.json`">
        </my-pagination>

        <my-dialog 
        title="退回" 
        v-model="dialogVisible" 
        width="500px"
        >
            <form-page 
                v-if="dialogVisible"
                :data="form"
                @cancle="dialogClose"
            ></form-page>
        </my-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

import FormPage from './form'

export default {
    mixins: [LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    components: { FormPage },
    data() {
        return {
            pgData: {
                sortname: 'addtime',
                sortorder: 'desc',
                pagesize: 20,
                ggcode:'',
                ggname:''
            },

            form: {}
        }
    },
    methods: {
        
    },
    created() {

    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
</style>
